import React, { ReactElement } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { BREED_DEFAULT_IMAGE } from '../../../utils/constants';
import { cloudinaryTransform } from '../../../utils/cloudinaryTransformations';
import { setFallbackImage } from '../../../utils/imageHelper';

interface BreedCardInterface {
  id: number,
  slug: string,
  name: string,
  thumbnailUrl: string | null,
  alternative_breed_names?: string[],
}

interface BreedCardProps {
  breed: BreedCardInterface;
  listingsType?: null | string;
}

const BreedCard: React.FC<BreedCardProps> = (data): ReactElement => {
  const { breed, listingsType } = data;

  return (
    <>
      <a href={`/breeds/${breed.slug}/${listingsType ?? ''}`}>
        <div key={breed.id} className="breed-card">
          <div className="card-img-top">
            <LazyLoadImage
              src={breed.thumbnailUrl
                ? cloudinaryTransform(
                  breed.thumbnailUrl,
                  [
                    't_lpr-full-transform',
                    'f_auto,q_auto',
                    'w_280',
                    'h_280',
                  ],
                ) : BREED_DEFAULT_IMAGE}
              alt={breed.name}
              style={{ maxWidth: '100%' }}
              onError={(e) => {
                setFallbackImage(e, BREED_DEFAULT_IMAGE);
              }}
            />
          </div>
          <div className="card-body text-center">
            <p>
              <strong>{breed.name}</strong>
            </p>
            {breed.alternative_breed_names && breed.alternative_breed_names.length > 0 && (
              <p className="px-2 m-0">{breed.alternative_breed_names.join(', ')}</p>
            )}
          </div>
        </div>
      </a>
    </>
  );
};

export default BreedCard;
